import { useAuth } from '@clerk/react'
import { useState } from 'react'
import { SignupLayout } from './SignupLayout'
import { EmailVerificationStep } from './steps/EmailVerificationStep'
import { OrgDetailsStep } from './steps/OrgDetailsStep'
import { UserDetailsStep } from './steps/UserDetailsStep'

type WizardStep = 'user-details' | 'email-verification' | 'org-details'

const SignupWizard = () => {
    const { isSignedIn } = useAuth()
    const [step, setStep] = useState<WizardStep>(
        isSignedIn ? 'org-details' : 'user-details',
    )

    const stepNumber =
        step === 'user-details' || step === 'email-verification' ? 1 : 2
    const totalSteps = 2

    return (
        <SignupLayout step={stepNumber} totalSteps={totalSteps}>
            {step === 'user-details' && (
                <UserDetailsStep
                    onVerificationNeeded={() => setStep('email-verification')}
                />
            )}
            {step === 'email-verification' && (
                <EmailVerificationStep
                    onVerified={() => setStep('org-details')}
                />
            )}
            {step === 'org-details' && <OrgDetailsStep />}
        </SignupLayout>
    )
}

export default SignupWizard
